const STEPS = [
  ["Pre", "Before you travel", "A private, in-depth personalized consultation, your wellbeing profile, a carefully curated itinerary, your at-home travel kit and gifts to accompany your LUXEWELL experience, and personalized concierge coordination."],
  ["Present", "During your experience", "A dedicated concierge on call, private transfers, personal introductions and discreet daily check-ins."],
  ["Post", "When you return", "Your 90-day integration plan, three follow-up check-ins, at-home rituals and an invitation to your next journey."],
];
const C = 150, R = 112;
const pt = (deg, r = R) => [C + r * Math.cos((deg * Math.PI) / 180), C + r * Math.sin((deg * Math.PI) / 180)];
const LABEL = [-90, 30, 150];
const RING = "Customized Conciergerie Care · Hospitality Excellence · Customized Conciergerie Care · Hospitality Excellence · ";

const Leaf = ({ x, y }) => (
  <path transform={`translate(${x} ${y})`} d="M0,-9 C6,-4 6,4 0,9 C-6,4 -6,-4 0,-9 Z M0,-9 L0,9" fill="none" stroke="url(#c360)" strokeWidth="1.1" />
);

function Circle() {
  return (
    <div className="flex flex-col items-center">
      <svg viewBox="0 0 300 300" className="w-72 h-72 lg:w-80 lg:h-80 overflow-visible" data-testid="care-360-circle">
        <defs>
          <linearGradient id="c360" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#B88A3E" /><stop offset="0.45" stopColor="#FFF1BF" /><stop offset="1" stopColor="#BE8F43" /></linearGradient>
          <path id="ring360" d={`M${C},${C} m-140,0 a140,140 0 1,1 280,0 a140,140 0 1,1 -280,0`} />
        </defs>
        <g className="origin-center animate-[spin_60s_linear_infinite]" style={{ transformBox: "view-box" }} data-testid="care-360-ring">
          <text fontSize="8.5" letterSpacing="2.2" fill="url(#c360)" style={{ fontFamily: "'Tenor Sans', sans-serif" }}><textPath href="#ring360">{RING.toUpperCase()}</textPath></text>
        </g>
        <circle cx={C} cy={C} r={R + 12} fill="none" stroke="url(#c360)" strokeWidth="0.6" opacity="0.6" />
        <circle cx={C} cy={C} r={70} fill="none" stroke="url(#c360)" strokeWidth="0.6" opacity="0.5" />
        {STEPS.map(([h], i) => { const [x, y] = pt(LABEL[i]); return (
          <g key={h}>
            <Leaf x={x} y={y - 14} />
            <text x={x} y={y + 8} textAnchor="middle" fontSize="9" letterSpacing="2" fill="#F3E3B5" style={{ fontFamily: "'Tenor Sans', sans-serif" }}>{h.toUpperCase()}</text>
          </g>
        ); })}
        <text x={C} y={C - 22} textAnchor="middle" fontSize="8" letterSpacing="2.4" fill="#F3E3B5" style={{ fontFamily: "'Tenor Sans', sans-serif" }}>CONCIERGERIE</text>
        <text x={C} y={C + 14} textAnchor="middle" fontSize="38" fill="url(#c360)" style={{ fontFamily: "'Cinzel', serif" }}>360°</text>
        <text x={C} y={C + 34} textAnchor="middle" fontSize="8" letterSpacing="2.4" fill="#F3E3B5" style={{ fontFamily: "'Tenor Sans', sans-serif" }}>CARE</text>
      </svg>
      <p className="mt-6 eyebrow !text-[0.7rem] text-center" data-testid="care-360-caption">High-Touch, Humanized Luxury</p>
    </div>
  );
}

export default function Care360() {
  return (
    <section className="bg-forest text-ivory" data-testid="care-360">
      <div className="px-6 lg:px-10 max-w-7xl mx-auto pt-10 lg:pt-24 pb-12 lg:pb-14">
        <p className="eyebrow mb-1">LUXEWELL Hospitality</p>
        <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight" data-testid="care-360-heading">OUR <span className="font-sign lowercase text-gold tracking-normal text-5xl lg:text-6xl">excellence</span></h2>
        <div className="mt-14 lg:mt-6 grid lg:grid-cols-[380px_1fr] gap-14 items-center">
          <Circle />
          <div className="max-w-xl">
            <div className="grid gap-px bg-[#E8D29B]/30 border border-[#E8D29B]/40">
              {STEPS.map(([h, sub, d]) => (
                <div key={h} className="bg-forest p-6 lg:p-7 flex gap-5" data-testid={`care-step-${h.toLowerCase()}`}>
                  <svg viewBox="-10 -10 20 20" className="w-5 h-5 shrink-0 mt-0.5" aria-hidden="true"><defs><linearGradient id={`lf-${h}`} x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#B88A3E" /><stop offset="0.5" stopColor="#FFF1BF" /><stop offset="1" stopColor="#BE8F43" /></linearGradient></defs><path d="M0,-9 C6,-4 6,4 0,9 C-6,4 -6,-4 0,-9 Z M0,-9 L0,9" fill="none" stroke={`url(#lf-${h})`} strokeWidth="1.2" /></svg>
                  <div>
                    <p className="eyebrow">{h} · <span className="!text-ivory/70">{sub}</span></p>
                    <p className="mt-3 text-sm text-ivory/85 leading-relaxed">{d}</p>
                  </div>
                </div>
              ))}
            </div>
            <p className="mt-3 text-[0.68rem] text-ivory/60 tracking-wide" data-testid="care-360-sub">Included with every LUXEWELL experience, beyond what your destination provides.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
